/**
 * Many services answer a write with { success, error } instead of throwing. A caller that only
 * awaits the call shows "saved" and patches its rows even when Firestore refused the write
 * (e.g. a permission error), so every such write goes through ensureSaved: it returns the reply
 * when the write went through and throws a readable Error when it did not.
 */
export const writeErrorText = (error) => {
    if (!error) return 'no reply from the server';
    if (typeof error === 'string') return error;
    return error.message || String(error);
};

export const ensureSaved = (res, what = 'Save') => {
    if (res && res.success) return res;
    throw new Error(`${what} failed: ${writeErrorText(res && res.error)}`);
};
